import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageReceivedNewGlobal } from 'entities/Conversation/events/EventMessageReceivedNewGlobal'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventMessageReceivedNew = (conversationMessageStore: ConversationMessagesStore) => {
  const { conversationStore, contactsStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    conversationStore.updateItem(data.conversation)
    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      conversationMessageStore.setItems([data.message])
    }
    if (data.contact) {
      contactsStore.updateItem(data.contact)
    }
  }

  useEventMessageReceivedNewGlobal(handler)
}
